import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import accountUtilities from '@totem/components/userContext/accountUtilities';

const Logout = () => {
  const navigate = useNavigate();
  const { logout: auth0Logout } = useAuth0();

  useEffect(() => {
    accountUtilities.logout();

    auth0Logout({ logoutParams: { returnTo: window.location.origin } });

    navigate('/login');
  }, []);

  return <Link to={'/login'}>Continue to login</Link>;
};

export default Logout;
